// Seeds Receiving Report: scanned bags → seed rows × period columns (lbs).
// A bag lands in the column of its scan date; the seed row is the plain sum of its bags.
import { periodOf } from './goodsOrderedReport';

// bags: [{ seedsID, seedName, bagId, lot, weight, date: 'YYYY-MM-DD', time: 'HH:mm' }]
// → { periods: [{ key, label }], seeds: [{ seedsID, name, bags: [{ ...bag, periodKey }] }] }
export function buildSeedsReport(bags, period) {
  const periods = new Map();
  const seeds   = new Map();
  for (const b of bags) {
    const p = periodOf(b.date, period);
    periods.set(p.key, p.label);
    let s = seeds.get(b.seedsID);
    if (!s) { s = { seedsID: b.seedsID, name: b.seedName || `#${b.seedsID}`, bags: [] }; seeds.set(b.seedsID, s); }
    s.bags.push({ ...b, periodKey: p.key });
  }
  for (const s of seeds.values()) {
    s.bags.sort((a, b) => (a.date + a.time).localeCompare(b.date + b.time) || a.bagId.localeCompare(b.bagId));
  }
  return {
    periods: [...periods.keys()].sort().map((key) => ({ key, label: periods.get(key) })),
    seeds:   [...seeds.values()].sort((a, b) => a.name.localeCompare(b.name)),
  };
}

// Σ weight of the given bags per period key, plus the overall total.
export function sumBags(bags) {
  const cells = {};
  let total = 0;
  for (const b of bags) {
    const w = Number(b.weight) || 0;
    cells[b.periodKey] = (cells[b.periodKey] || 0) + w;
    total += w;
  }
  return { cells, total };
}

// Quick search: seed name / Seed ID match the whole seed; LOT / BAG ID match single bags.
// Returns the bags to show for the seed, or null when nothing matches.
export const seedMatches = (seed, q) => seed.name.toLowerCase().includes(q) || String(seed.seedsID) === q;

export function visibleBags(seed, q) {
  if (!q || seedMatches(seed, q)) return seed.bags;
  const hits = seed.bags.filter((b) => (b.bagId || '').toLowerCase().includes(q) || (b.lot || '').toLowerCase().includes(q));
  return hits.length ? hits : null;
}
